import * as z from "zod/v4";

export const updateTripleWhaleOmsSettings = {
  name: "updateTripleWhaleOmsSettings" as const,
  input: z.object({ enabled: z.boolean() }),
  output: z.object({ success: z.boolean() }),
};
